<template>
  <div>
    <v-card class="mb-4">
      <v-layout class="px-4 py-2" wrap>
        <v-flex xs12 md4>
          <v-select
            v-model="reportType"
            :loading="loading"
            :label="$tc('common.Report')"
            :items="reportTypes"
            item-text="label_pt"
            item-value="reporter_name"
            no-data-text="Nenhum disponível"
          />
          <LogDateFilter :logs="logs" @filterMap="dateFilterMap = $event" />
        </v-flex>
        <v-flex xs12 md4>
          <v-btn
            class="ma-2"
            color="success"
            @click="getReport"
            :disabled="loading || !reportType || filteredLogs.length === 0"
            >Obter ({{ filteredLogs.length }})</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card>
    <v-card v-if="report">
      <v-btn @click="copyReport()"
        ><i class="fas fa-copy mr-2"></i>Copiar</v-btn
      >
      <v-layout class="px-4 py-4" wrap id="report">
        <div v-html="report"></div>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Component } from '@/models/Specialty'
import Specialty from '@/models/Specialty'
import specialtyFetcher from '../../mixins/specialtyFetcher'
import reportsFetcher from '../../mixins/reportsFetcher'
import LogDateFilter from '@/components/LogDateFilter'

export default {
  components: {
    LogDateFilter
  },
  data: () => ({
    loadingSpecialty: true,
    loadingReporters: true,
    loadingLogs: true,
    report: '',
    reportType: null,
    reportTypes: [],
    dateFilterMap: null
  }),
  mixins: [reportsFetcher, specialtyFetcher],
  computed: {
    loading() {
      return this.loadingSpecialty || this.loadingReporters || this.loadingLogs
    },
    specialty() {
      return Specialty.getSpecific(this.$store.getters.specialty)
    },
    logs() {
      return this.loading ? [] : this.$store.getters.logs
    },
    components() {
      return (
        Component.query()
          .withAllRecursive()
          .get() || []
      )
    },
    labeledLogs() {
      const logs = this.filteredLogs.map(log => {
        const labeledLog = Object.assign({}, log)
        this.components.forEach(c => {
          labeledLog[c.id] = log[c.id]
          labeledLog[`${c.id}:text`] = this.getLabel(log, c)
        })
        return labeledLog
      })
      return logs
    },
    filteredLogs() {
      const filteredLogs = []
      for (let i = 0; i < this.logs.length; i++) {
        if (!this.dateFilterMap || this.dateFilterMap[i]) {
          filteredLogs.push(this.logs[i])
        }
      }
      return filteredLogs
    }
  },
  methods: {
    ...mapActions(['getLogs']),
    getLabel(log, component) {
      return this.specialty.getLabel(log, component)
    },
    copyReport() {
      let range = document.createRange()
      let containerNode = document.getElementById('report')
      range.selectNode(containerNode)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
      document.execCommand('copy')
      window.getSelection().removeAllRanges()
      this.$store.dispatch(
        'showSuccessSnackbar',
        'Dados copiados para a área de transferência'
      )
    }
  },
  created() {
    this.fetchSpecialtyIfEmpty()
      .then(() => {
        this.getLogs()
          .catch(err =>
            this.showErrorSnackbar(err.message || 'Something went wrong')
          )
          .finally(() => (this.loadingLogs = false))
      })
      .finally(() => (this.loadingSpecialty = false))
    this.getAvaliableReports().then(() => {
      this.$emit('reportsAvaliable', this.reportTypes.length > 0)
    })
  }
}
</script>

<style no-scope>
#report {
  -webkit-user-select: text !important;
  user-select: text !important;
}
.dataframe {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse !important;
  border: 0;
  width: 100%;
}

#report td,
#report th {
  border: 1px solid #ddd;
  padding: 8px;
}

#report tr:nth-child(even) {
  background-color: #f2f2f2;
}

#report tr:hover {
  background-color: #ddd;
}

#report th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4caf50;
  color: white;
}

#report .vertical-col-headers thead th span {
  writing-mode: vertical-lr;
  transform: rotate(-180deg);
}
</style>
